import { type } from '@/utils/type'

export const UI_CLOSE_SNACKBAR = type('UI_CLOSE_SNACKBAR')
export const UI_ADD_SNACK_MESSAGE = type('UI_ADD_SNACK_MESSAGE')

export const UI_SET_CONTENT_HEIGHT = type('UI_SET_CONTENT_HEIGHT')
export const UI_SET_RIGHT_DRAWER_OPEN = type('UI_SET_RIGHT_DRAWER_OPEN')
export const UI_SET_RIGHT_DRAWER_ENABLE = type('UI_SET_RIGHT_DRAWER_ENABLE')

export const UI_SET_DRAWER_OPEN = type('UI_SET_DRAWER_OPEN')
export const UI_SET_DRAWER_ENABLE = type('UI_SET_DRAWER_ENABLE')

export const UI_SET_CART_VISIBLITY = type('UI_SET_CART_VISIBLITY')

export const UI_SET_SEARCH_USER = type('UI_SET_SEARCH_USER')
export const UI_SET_SORT_USER_DESC = type('UI_SET_SORT_USER_DESC')
export const UI_SET_SORT_USER_BY = type('UI_SET_SORT_USER_BY')

export const UI_SET_SEARCH_MAIL_TEMPLATE = type('UI_SET_SEARCH_MAIL_TEMPLATE')
export const UI_SET_SORT_MAIL_TEMPLATE_DESC = type('UI_SET_SORT_MAIL_TEMPLATE_DESC')
export const UI_SET_SORT_MAIL_TEMPLATE_BY = type('UI_SET_SORT_MAIL_TEMPLATE_BY')

export const UI_SET_SEARCH_MAIL_SKIN = type('UI_SET_SEARCH_MAIL_SKIN')
export const UI_SET_SORT_MAIL_SKIN_DESC = type('UI_SET_SORT_MAIL_SKIN_DESC')
export const UI_SET_SORT_MAIL_SKIN_BY = type('UI_SET_SORT_MAIL_SKIN_BY')

export const UI_SET_SEARCH_PISCINE = type('UI_SET_SEARCH_PISCINE')
export const UI_SET_SORT_PISCINE_DESC = type('UI_SET_SORT_PISCINE_DESC')
export const UI_SET_SORT_PISCINE_BY = type('UI_SET_SORT_PISCINE_BY')
export const UI_SET_MONTH_PISCINE = type('UI_SET_MONTH_PISCINE')

export const UI_SET_SEARCH_ACTIVITY = type('UI_SET_SEARCH_ACTIVITY')
export const UI_SET_SORT_ACTIVITY_DESC = type('UI_SET_SORT_ACTIVITY_DESC')
export const UI_SET_SORT_ACTIVITY_BY = type('UI_SET_SORT_ACTIVITY_BY')

export const UI_SET_SEARCH_FORFAIT = type('UI_SET_SEARCH_FORFAIT')
export const UI_SET_SORT_FORFAIT_DESC = type('UI_SET_SORT_FORFAIT_DESC')
export const UI_SET_SORT_FORFAIT_BY = type('UI_SET_SORT_FORFAIT_BY')

export const UI_SET_SEARCH_MNS = type('UI_SET_SEARCH_MNS')
export const UI_SET_SORT_MNS_DESC = type('UI_SET_SORT_MNS_DESC')
export const UI_SET_SORT_MNS_BY = type('UI_SET_SORT_MNS_BY')

export const UI_SET_SEARCH_CONTACT = type('UI_SET_SEARCH_CONTACT')
export const UI_SET_SORT_CONTACT_DESC = type('UI_SET_SORT_CONTACT_DESC')
export const UI_SET_SORT_CONTACT_BY = type('UI_SET_SORT_CONTACT_BY')
export const UI_SET_MONTH_CONTACT = type('UI_SET_MONTH_CONTACT')

export const UI_SET_SEARCH_NEWSLETTER = type('UI_SET_SEARCH_NEWSLETTER')
export const UI_SET_SORT_NEWSLETTER_DESC = type('UI_SET_SORT_NEWSLETTER_DESC')
export const UI_SET_SORT_NEWSLETTER_BY = type('UI_SET_SORT_NEWSLETTER_BY')

export const UI_SET_SEARCH_COURS = type('UI_SET_SEARCH_COURS')
export const UI_SET_SORT_COURS_DESC = type('UI_SET_SORT_COURS_DESC')
export const UI_SET_SORT_COURS_BY = type('UI_SET_SORT_COURS_BY')

export const UI_SET_SEARCH_COMMANDE = type('UI_SET_SEARCH_COMMANDE')
export const UI_SET_SORT_COMMANDE_DESC = type('UI_SET_SORT_COMMANDE_DESC')
export const UI_SET_SORT_COMMANDE_BY = type('UI_SET_SORT_COMMANDE_BY')
export const UI_SET_MONTH_COMMANDE = type('UI_SET_MONTH_COMMANDE')

export const UI_SET_SEARCH_FAMILY = type('UI_SET_SEARCH_FAMILY')
export const UI_SET_SORT_FAMILY_DESC = type('UI_SET_SORT_FAMILY_DESC')
export const UI_SET_SORT_FAMILY_BY = type('UI_SET_SORT_FAMILY_BY')
